import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Drawer from 'material-ui/Drawer';
import Menu from 'material-ui/Menu';
import Divider from 'material-ui/Divider';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import KeyIcon from 'material-ui/svg-icons/communication/vpn-key';
import {
  Link,
  Route,
} from 'react-router-dom';
import _ from 'lodash';
import Cookies from 'universal-cookie';

import * as history from '../../common/history.js';
import Display from './displays/Display.js';
import Brand from './brands/Brand.js';
import Queue from './queues/Queue.js';
import User from './users/User.js';
import Account from './accounts/Account.js';
import Counter from './counters/Counter.js';
import Report from './reports/Report.js';
import Other from './others/Other.js';
import Dialogs from "../../common/Dialogs.js";
import constants from "../../common/constants";
import * as DataAPI from "../../common/DataAPI";
import * as SocketIO from "../../common/SocketIO";

const cookies = new Cookies();

class Panel extends Component {
  constructor() {
    super();

    this.state = {
      menuItems: [
        {
          link: '/adminPanel/panel/display',
          name: '屏幕管理',
          isActive: false,
        },
        // {
        //   link: '/adminPanel/panel/brand',
        //   name: '品牌管理',
        //   isActive: false,
        // },
        {
          link: '/adminPanel/panel/user',
          name: '用戶管理',
          isActive: false,
        },
        {
          link: '/adminPanel/panel/queue',
          name: '隊伍管理',
          isActive: false,
        },
        // {
        //   link: '/adminPanel/panel/account',
        //   name: 'SMS帳戶',
        //   isActive: false,
        // },
        // {
        //   link: '/adminPanel/panel/counter',
        //   name: '櫃枱管理',
        //   isActive: false,
        // },
        {
          link: '/adminPanel/panel/report',
          name: '報告',
          isActive: false,
        },
        {
          link: '/adminPanel/panel/other',
          name: '其他',
          isActive: false,
        },
      ],
      isLicenseValid: true,
      licenseEndDate: '',
      shouldShowLicenseInputDialog: false,
      licenseKey: '',
    };

    this.logout = this.logout.bind(this);
    this.changeActiveMenuItem = this.changeActiveMenuItem.bind(this);
    this.updateLicenseKey = this.updateLicenseKey.bind(this);
    this.openLicenseInputDialog = this.openLicenseInputDialog.bind(this);
    this.closeLicenseInputDialog = this.closeLicenseInputDialog.bind(this);
    this.updateState = this.updateState.bind(this);
  }

  componentWillMount() {
    const defaultLocation = '/adminPanel/panel/queue';
    if (history.getCurrentLocation() === '/adminPanel/panel') history.replace(defaultLocation);

    const currentMenuItemIndex = _.findIndex(this.state.menuItems, { link: history.getCurrentLocation() });
    if (currentMenuItemIndex !== -1) {
      this.changeActiveMenuItem(currentMenuItemIndex);
    } else {
      // Default first menu item
      this.changeActiveMenuItem(0);
      history.replace(_.head(this.state.menuItems).link);
    }

    this.fetchLicenseStatus();
  }

  componentDidMount() {
    SocketIO.on('validateLicense', () => {
      if (constants.shouldCheckLicenseEndDate) {
        this.fetchLicenseStatus();
      }
    });
  }

  fetchOfflineLicenseStatus(cb = constants.emptyFnc) {
    if (!constants.shouldCheckLicenseEndDate) {
      return this.setState({
        isLicenseValid: true,
      }, cb);
    }

    DataAPI.get('/api/adminPanel/offlineLicenseStatus', {}, (err, license) => {
      if (err) this.dialogs.error(err);

      this.setState({
        licenseEndDate: license.endDate,
        isLicenseValid: err ? false : license.isValid,
      }, cb);
    });
  }

  fetchLicenseStatus(cb = constants.emptyFnc) {
    if (!constants.shouldCheckLicenseEndDate) {
      return this.setState({
        isLicenseValid: true,
      }, cb);
    }

    DataAPI.get('/api/adminPanel/licenseStatus', {}, (err, license) => {
        if (err) this.dialogs.error(err);

        this.setState({
          licenseEndDate: _.get(license, 'endDate'),
          isLicenseValid: err ? false : license.isValid,
        }, cb);
      }
    );
  }

  updateLicenseKey(key, cb = constants.emptyFnc) {
    DataAPI.post('/api/adminPanel/updateLicenseKey/' + key, {}, (err, license) => {
      this.closeLicenseInputDialog();

      if (err) return this.dialogs.error(err);

      this.dialogs.alert({
        title: '成功更新金鑰。',
      });
    });
  }

  changeActiveMenuItem(activeMenuIndex) {
    let menuItems = _.cloneDeep(this.state.menuItems);

    menuItems = _.map(menuItems, (menuItem, index) => {
      menuItem.isActive = index === activeMenuIndex;

      return menuItem;
    });

    this.setState({ menuItems });
  };

  logout() {
    cookies.remove('isLoggedIn', { path: '/' });

    history.replace('/adminPanel');

    window.location.reload();
  }

  openLicenseInputDialog() {
    this.setState({
      shouldShowLicenseInputDialog: true,
    });
  }

  closeLicenseInputDialog() {
    this.setState({
      shouldShowLicenseInputDialog: false,
    });
  }

  updateState(field, value) {
    this.setState({
      [field]: value,
    });
  }

  render() {
    const licenseInputDialogActions = [
      <FlatButton
        label="取消"
        primary={true}
        onClick={this.closeLicenseInputDialog}
      />,
      <FlatButton
        label="更新"
        primary={true}
        onClick={this.updateLicenseKey.bind(this, this.state.licenseKey)}
      />,
    ];

    const wrapOnChange = (fnc, field, event, value) => {
      fnc(field, value);
    };

    return (
      <div className="admin-panel-panel-block">
        <div className="main-panel">
          <div className="panel-block">
            <Route path="/adminPanel/panel/display" component={Display} />
            {/*<Route path="/adminPanel/panel/brand" component={Brand} />*/}
            <Route path="/adminPanel/panel/user" component={User} />
            <Route path="/adminPanel/panel/queue" component={Queue} />
            <Route path="/adminPanel/panel/account" component={Account} />
            {/*<Route path="/adminPanel/panel/counter" component={Counter} />*/}
            <Route path="/adminPanel/panel/report" component={Report} />
            <Route path="/adminPanel/panel/other" component={Other} />
          </div>
        </div>
        <Drawer docked={true} width={200}>
          <Menu>
            <RaisedButton label="登出" onClick={this.logout} primary={true}
                          className="back-btn" />
            <Divider />
            <div className="menu-item-container">
              {
                _.map(this.state.menuItems, (menuItem, index) =>
                  <MenuItem key={index}
                            containerElement={<Link to={menuItem.link} />}
                            onClick={this.changeActiveMenuItem.bind(this, index)}
                            className={(menuItem.isActive ? 'active' : '')}>
                    {menuItem.name}
                  </MenuItem>
                )
              }
            </div>
            {
              constants.shouldCheckLicenseEndDate &&
              <div className="license-key-block">
                <div className="text">訂閱有效至：{this.state.licenseEndDate}</div>
                {/*<RaisedButton*/}
                  {/*label={'輸入金鑰'}*/}
                  {/*icon={<KeyIcon />}*/}
                  {/*onClick={this.openLicenseInputDialog}*/}
                {/*/>*/}
              </div>
            }
          </Menu>
        </Drawer>
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
        <Dialog
          title="輸入金鑰"
          actions={licenseInputDialogActions}
          modal={false}
          open={this.state.shouldShowLicenseInputDialog}
          onRequestClose={this.closeLicenseInputDialog}
        >
          <TextField
            name="licenseKey"
            value={this.state.licenseKey}
            onChange={wrapOnChange.bind(this, this.updateState, 'licenseKey')}
            type="text"
          />
        </Dialog>
      </div>
    )
  }
}

export default Panel;


// WEBPACK FOOTER //
// client/adminPanel/panel/Panel.js